// extracted by mini-css-extract-plugin
module.exports = {"container":"custom-footer_container_2LhMy","footer-copyright":"custom-footer_footer-copyright_3U9Dd"};